import React, { useRef, useEffect, useState } from "react";
import { classNames } from "utils/utils";
import { IonButton, IonButtons, IonLabel, IonToolbar } from "@ionic/react";
import { useGame } from "context/gameContext";

import { useTranslation } from "react-i18next";
import { useModalContext } from "context/modalContext";

const PremiumAd = () => {
  const {
    state: { settings, premium },
  } = useGame();
  const { t } = useTranslation();
  const { openPaywallModal } = useModalContext();
  const subscribeModal = () => {
    openPaywallModal();
  };

  return !premium && settings?.showPremiumBanner ? (
    <IonToolbar className="premiumToolbar">
      <IonLabel slot="start">
        <div className="grid w-full overflow-hidden pl-2 text-xs">
          <div className="truncate whitespace-nowrap font-semibold">
            {t("premium.banner_header")}
          </div>
          <div className="truncate whitespace-nowrap">
            {t("premium.banner_subheader")}
          </div>
        </div>
      </IonLabel>
      <IonButtons slot="end">
        <IonButton
          detail="false"
          expand="block"
          onClick={subscribeModal}
          className="customButton noOpacity "
          id="open-modal"
          mode="ios"
          fill="outline"
          color="dark"
        >
          <IonLabel className="text-sm">{t("premium.banner_button")}</IonLabel>
        </IonButton>
      </IonButtons>
    </IonToolbar>
  ) : (
    <></>
  );
};

export default PremiumAd;
